import moment from "moment";

import { TransferableAddress, TransferableEmail, TransferablePatientInfoResponse, TransferablePhone } from "@/Common/Api/ExternalCommunications/Dto/TransferablePatientInfoResponse";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface ITransferablePatientInfoProps {
    patient: TransferablePatientInfoResponse;
    onPatientInfoClick?: (selectedSearchText: string) => void;
}

class TransferablePatientInfoComponent extends React.Component<ITransferablePatientInfoProps, any> {
    private validationHelper: ValidationHelper = new ValidationHelper();

    public render(): JSX.Element {
        let prefix = cacheStore.GetLocalizedValueByLookupId(this.props.patient.Prefix?.Id);
        let dobString = this.props.patient.DateOfBirth ? moment(this.props.patient.DateOfBirth).format("YYYY/MM/DD") : "";
        let ageString = dobString ? `(${PatientHelper.getFormattedAge(new Date(dobString))})` : "";
        let healthCard = !isArrayNullOrUndefinedOrEmpty(this.props.patient.HealthIdentifiers) ? this.props.patient.HealthIdentifiers[0].Value : "";
        let searchablePatientName = `${this.props.patient.LastName} ${this.props.patient.FirstName}`;

        return (
            <div>
                <div className="flex-container" style={{ justifyContent: "flex-start", paddingBottom: "20px" }}>
                    <div><img src={img_p_banner_icon_100} alt="MYLE" style={{ width: "48px", marginRight: "20px" }} /></div>
                    <div>
                        <div> {prefix} <a style={{ fontSize: "16px" }} onClick={() => this.handlePatientInfoClick(searchablePatientName)}> {this.props.patient.LastName.toUpperCase()}, {this.props.patient.FirstName}</a></div>
                        <div><span>{sessionStore.getDefaultHealthCardLabel()}</span> <a onClick={() => this.handlePatientInfoClick(healthCard)}> {healthCard} </a></div>
                        <div><span>{cacheStore.GetString("DateofBirthLabel")}</span> <strong>{dobString} {ageString}</strong></div>
                    </div>
                </div>

                <div style={{ marginBottom: "5px" }}>
                    {this.renderPhones(this.props.patient.Phones)}
                    {this.renderAddresses(this.props.patient.Addresses)}
                    {this.renderEmails(this.props.patient.Emails)}
                </div>
            </div>
        );
    }

    private renderEmails(emails: TransferableEmail[]): JSX.Element {
        if (isArrayNullOrUndefinedOrEmpty(emails))
            return <div />;

        let emailList = emails.map(email => {
            let contactType = email.ContactType
                ? `(${cacheStore.GetLocalizedValueByLookupId(email.ContactType.Id)})`
                : "";
            return (
                <li key={email.Address}>
                    <div>
                        {`${email.Address} ${contactType}`}
                    </div>
                </li>
            );
        });

        return (
            <ul>
                <h5 className="text-uppercase" style={this.titleStyle}>{cacheStore.GetString("EmailLabel")}</h5>
                {emailList}
            </ul>
        );
    }

    private renderPhones(phones: TransferablePhone[]): JSX.Element {
        if (isArrayNullOrUndefinedOrEmpty(phones))
            return <div />;

        let phoneList = phones.map(phone => {
            let validationRule = this.validationHelper.getPhoneNumberValidationRule(phone.Country?.Id, null);
            let displayFormatSelector = validationRule ? validationRule.DisplayFormatSelectorPatern : "";
            let displayFormatSubstitution = validationRule ? validationRule.DisplayFormatSubstitution : "";
            let formattedPhone = ValidationHelper.cleanPhoneNumber(phone.PhoneNumber, phone.Country?.Id);
            let formattedPhoneString = this.validationHelper.getFormatedString(formattedPhone, displayFormatSelector, displayFormatSubstitution);

            return (
                <li key={phone.PhoneNumber}>
                    <div>
                        <h5 style={this.titleStyle} />
                        <div>
                            <span className="myle-icon-16 phone" />
                            <a className="bold" onClick={() => this.handlePatientInfoClick(formattedPhone)}>{formattedPhoneString}</a> {this.renderPhoneContactType(phone.ContactType?.Id, phone.Type?.Id)}
                        </div>
                    </div>
                </li>
            );
        });

        return <ul>{phoneList}</ul>;
    }

    private renderPhoneContactType(contactTypeId: string, phoneTypeId: string): JSX.Element {
        if (!contactTypeId && !phoneTypeId)
            return null;

        return (
            <span>({cacheStore.GetLocalizedValueByLookupId(contactTypeId)} - {cacheStore.GetLocalizedValueByLookupId(phoneTypeId)}) </span>
        );
    }

    private renderAddresses(addresses: TransferableAddress[]): JSX.Element {
        if (isArrayNullOrUndefinedOrEmpty(addresses))
            return <div style={{ marginTop: "20px" }} />;

        let addressList = addresses.map(address => (
            <li key={address.StreetAddress} style={{ paddingBottom: "10px" }}>
                <div><strong>{address.StreetAddress}</strong></div>
                <div>
                    <strong>{address.City}</strong>
                    {address.Region &&
                        <strong>, {cacheStore.GetLocalizedValueByLookupId(address.Region?.Id)}</strong>
                    }
                </div>
                <div><strong>{address.PostalCode}</strong></div>
            </li>
        ));

        return (
            <div style={{ marginTop: "20px" }}>
                <h5 className="text-uppercase" style={this.titleStyle}>{cacheStore.GetString("AddressLabel")}</h5>
                <ul>{addressList}</ul>
            </div>
        );
    }

    private get titleStyle(): React.CSSProperties {
        return { margin: "0 0 10px 0", borderBottom: "solid 1px #aeaeae" } as React.CSSProperties;
    }

    private handlePatientInfoClick(patientInfo: string): void {
        this.props.onPatientInfoClick && this.props.onPatientInfoClick(patientInfo);
    }
}

export { TransferablePatientInfoComponent };
